import {useEffect, useState} from 'react';
import {useChekinSDK} from './useChekinSDK';

export function useIsTokenReady(): boolean {
  const {isTokenValid} = useChekinSDK();
  const [isTokenReady, setIsTokenReady] = useState(false);

  useEffect(() => {
    if (!isTokenValid || isTokenReady) {
      return;
    }
    const timeoutId = setTimeout(() => setIsTokenReady(true));
    return () => clearTimeout(timeoutId);
  }, [isTokenValid, isTokenReady]);

  return isTokenReady;
}
